import React from 'react';
import './ReportIssueForm.css';
import { ReactComponent as ErrorIcon } from '../images/error.svg';

function ReportIssueError(props) {
  return (
    <div className="field-error">
      <ErrorIcon className="field-error-icon" />
      {props.children}
    </div>
  );
}

export default ReportIssueError;
